<template>
    <div class="ui-content dashboard line-chart-scroll"> 
        <div class="chart-page">
            <v-row>
                <v-col cols="4" sm="4" class="paddintp0"></v-col>
                <v-col cols="4" sm="4" class="paddintp0">
                    <div class="chart-top-btn mr-15-top">
                        <v-btn class="sub-btn active" outlined>Batch Percentile</v-btn>
                        <v-btn class="sub-btn" outlined>Institute percentile</v-btn>
                    </div>
                </v-col>
                <v-col cols="4" sm="4" class="paddintp0"></v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" class="paddintp0">
                    <div id="chart" class="line-chart">
                        <div class="text-area">
                            <div CLASS="rotated-block">Percentile </div>
                        </div>
                        <div class="chart-area">
                            <div id="chart-line">
                                <apexchart type="line" height="400" :options="chartOptions" :series="series"></apexchart>
                            </div>
                            <div class="testnumber">Tast Number</div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChapterStanding',
    data () {
        return {
            series: [{
                name: 'series',
                data: [10 , 20 , 30 , 4 , 50 , 6 , 7 , 18 , 19 , 60 , 11 , 20 , 30 , 14 , 15 , 30 , 17 , 18 , 19 , 28 , 21 , 24 , 3 , 40 , 50]
            }],
            chartOptions: {
                chart: {
                id: 'fb',
                group: 'social',
                type: 'line',
                height: 400,
                toolbar: {
                        show: false,
                    }
                },
                colors: ['#008FFB'],
                yaxis: {
                labels: {
                    minWidth: 40
                }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['#2698D4']
                },
                xaxis: {
                    categories: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25'],
                },
            },     
        }
    }
}
</script>